<template>
    <section>
        <Navbar/>
        <Spinner v-if="isLoading" :color="'text-light'" />
        <div class="calltoaction">
            
            <section class="row" v-if="!isLoading">
                <div class="col-sm-9 text-center">
               <div class="col-xs-12 col-sm-12 py-3">
                    <div class="card">
                        <div class="card-header">
                            <h2>{{debate.topic}}</h2>
                        </div>
                        <div class="card-body">
                            <p v-if="author" class="blog-post-meta pb-4">{{author.date && author.date}} by {{author.author}}</p>
                            <p v-if="!author" class="blog-post-meta pb-4">{{debate.created_at && debate.created_at | moment}} 
                                by <a href="#">{{debate.created_by && debate.created_by[0].first_name}} {{debate.created_by && debate.created_by[0].last_name}}</a></p>
                                 <img v-if="author" class="img-thumbnail" :src="author.image" alt="">
                                <img v-if="debate.pic" class="img-thumbnail" :src="debate.pic" alt="">
                            <p class="pt-4 text-justify">{{debate.body}}</p>
                        </div>
                        <div class="card-footer">
                            <button class="mx-3" v-if="debate.thesis.length == 0"  @click="addLeadOpinion(debate.id)">ADD LEAD OPINION</button>
                           <div class="row" v-if="author">
                            <div class="col-12">
                            <hr>
                            <p>
                            <strong class="text-danger" style="font-size:1.6em">Note</strong>
                                This article first appears on <a target="_blank" :href="author.source">{{author.sourcename}}</a>, and is reproduced here on a fair use basis. Where <a target="_blank" :href="author.source">{{author.sourcename}}</a> is the original place where it was published.
                            </p>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                </div>
                <div class="col-sm-3">
                    <DebateSidebar/>
                </div>
            </section>
        </div>
        <FinalFooter />
    </section>
</template>

<script>
/* allow-no-unused-vars */
import FinalFooter from '../FinalFooter'
import Navbar from '../appBar'
import DebateSidebar from '../debateSidebar'
import authors from '../../helpers/debates'
import Spinner from '@/components/Spinner'
import moment from 'moment'
import { months } from 'moment'
    export default {
        components:{
            Navbar,
            Spinner,
            DebateSidebar,
            FinalFooter
        },
          filters: {
        moment: function (date) {
            return moment(date).format('MMMM Do YYYY');
        }
        },
        data() {
            return {
                debate: {},
                author:{},
                isLoading:false,
            }
        },
        methods:{
            addLeadOpinion(id) {
            const user = this.$session.get('entity')
          
                 if(!user) {
                window.location.replace(`/redirect?service=login`)
            }
            
            this.$router.replace(`/debate/${id}/add_lead_opinion`)
        },
            fetchDebateDetails(){
                this.isLoading = true
                this.$store.dispatch('fetchApprovedDebateArticle')
                .then(response =>{

                    const data = response.data.find(debate => debate.id == this.$route.params.debateId)
                    this.debate = data
                     if(!data) {
                         this.$router.replace({name:'pageNotfound'})
                     }
                     const author = authors.find(author => author.id == this.$route.params.debateId)
                     this.author = author
                     this.isLoading = false
                    
                })
                .catch(err => {
                    this.isLoading = false
                    //     if(err?.response?.data == undefined) {
                    //     this.toast({
                    //         message:'Network error. Check network connection and try again.',
                    //         type:'error'
                    //     })
                    // }
                    })
            }
        },
         mounted() {
        document.querySelector('body').setAttribute('style', 'background-color:#ba2428')
        this.$store.dispatch('fetchLeadersVision').then(response => console.log(response))
        this.fetchDebateDetails()
        
    },
    beforeDestroy() {
        document.querySelector('body').removeAttribute('style')
    },
    }
</script>

<style >

.calltoaction{
    padding-top: 150px;
    padding-left: 10px;
    padding-right: 10px;
}
.card-user {
  position: absolute;
  right: 10px;
  top: 10px;
}
.card-category {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 20px;
}
h2{
    text-transform: uppercase;
}
  .blog-post-meta {
    margin-bottom: 20px;
    color: #999;
    }
  button{
        background-color: #bb3826;
        color:#fff;
        border:1px solid #bb3826;
        padding:10px;
        transition: all 0.5s;
        outline: 0;
        font-size: .9em;
    }
    button:hover, button:active{
        background-color:#ffc106;
        color: #ad5457 ;
    }
</style>